/** Options read only by `typeahead-sublocation` (kept out of dynamic.interface.ts, WI 34968). */
export interface IDynamicSublocationOptions {
  /**
   * WI 34968 (NCR Quarantine location): accept any text. The list is scoped to the
   * app-selected warehouse (named under the field), an unknown value shows a non-blocking
   * warning, and nothing creates a sub-location. Set `valueProperty: 'location'` with it, or
   * the saved answer is empty. Unset, the control behaves as Tool Tracker pages expect.
   */
  sublocationFreeText?: boolean;
}
